import DefaultMainPage from "../../pages/DefaultMainPage";
import Campaign from "./Campaign";
import NewMailTitle from "./NewMailTitle";

const campaignMenuItems = [
    {path: "/campaign", component: <Campaign/>,  label: '전체 우편 관리'},
    {path: "/campaign/mailTitle", component: <NewMailTitle/>, label: '우편 타이틀 관리'},
];

export const campaignRoutes = {
    path: "/campaign",
    component: <DefaultMainPage buttons={campaignMenuItems}/>,
    children: campaignMenuItems
}